import React, { useEffect, useState } from "react";
import { Getagencypatientdetails } from "../../api/helper";
import SubscriptionVerify from "./SubscriptionVerify";
import PatinetPrivatePayVerify from "./PatinetPrivatePayVerify";
import InsuranceDetails from "../AgencyFlow/AgencyScreens/Patientinfoeditscreens/InsuranceScreens/InsuranceDetails";
import InsuranceDetailsVerify from "./InsuranceDetailsVerify";

const BillingProfile = ({ data, appointmentdetail, onComplete }) => {
  const [paymentMethod, setPaymentMethod] = useState("");
  const [info, setInfo] = useState(null);

 const handleSave = () => {
      onComplete?.(true);
  };

  const handlePaymentChange = (event) => {
    setPaymentMethod(event.target.value);
  };
  const getDteails = async () => {
    const response = await Getagencypatientdetails(data?.pateintRequestId);
    // console.log(response?.data?.data,"getdetails=-=-=")
    setInfo(response.data.data);
  };
  useEffect(() => {
    getDteails();
  }, []);
  return (
    <div className="basic-info-form">
      <h2>Payment Form</h2>
      <p className="form-description">
        Please complete the Payment form. All fields marked with * are required.
      </p>
      <form>
        <label>Choose a method of payment *</label>
        <div className="payment-options_verify" onChange={handlePaymentChange}>
          <label className="payment-option_verify">
            <input
              type="radio"
              name="paymentMethod"
              value="insurance"
              required
            />
            Bill the Client's Insurance
          </label>
          <label className="payment-option_verify">
            <input type="radio" name="paymentMethod" value="privatePay" />
            Private Pay (Out-of-Pocket)
          </label>
          <label className="payment-option_verify">
            <input type="radio" name="paymentMethod" value="subscription" />
            Subscription Plan
          </label>
        </div>

        {/* Insurance Fields */}
        {paymentMethod === "insurance" && (
          <InsuranceDetailsVerify info={info} />
          // <div id="insuranceFields" style={{ marginTop: "1rem" }}>
          //   <div className="form-group_CalendarView">
          //     <label htmlFor="insuranceProvider">Insurance Provider *</label>
          //     <select id="insuranceProvider" required>
          //       <option value="">Select your insurance provider</option>
          //       <option value="Aetna">Aetna</option>
          //       <option value="Blue Cross">Blue Cross</option>
          //       <option value="Cigna">Cigna</option>
          //       <option value="UnitedHealthcare">UnitedHealthcare</option>
          //     </select>
          //   </div>
          //   <label htmlFor="policyNumber">Policy Number *</label>
          //   <input
          //     type="text"
          //     id="policyNumber"
          //     placeholder="Enter your policy number"
          //   />
          //   <label htmlFor="groupNumber">Group Number *</label>
          //   <input
          //     type="text"
          //     id="groupNumber"
          //     placeholder="Enter your group number"
          //   />
          //   <label htmlFor="insuranceFront">Insurance Card Front *</label>
          //   <input type="file" id="insuranceFront" accept="image/*" />
          //   <label htmlFor="insuranceBack">Insurance Card Back *</label>
          //   <input type="file" id="insuranceBack" accept="image/*" />
          // </div>
        )}

     
        {paymentMethod === "privatePay" && (
          <PatinetPrivatePayVerify
            info={info}
            getDteails={getDteails}
            appointmentdetail={appointmentdetail}
          />
        )}

        {/* Subscription Fields */}
        {paymentMethod === "subscription" && (
          <SubscriptionVerify
            info={info}
            getDteails={getDteails}
            appointmentdetail={appointmentdetail}
          />
        )}
      </form>
      <button
        className="cta-button"
        id="completeForm"
        type="button"
        style={{ marginTop: 20, width: "100%" }}
         onClick={handleSave}
      >
        Save
      </button>
    </div>
  );
};

export default BillingProfile;
